import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import Button, { BUTTON_HEIGHT_40 } from '../../../../Button'
import { ButtonTextSelectControl, useSelectContext } from '../../../../Select'
import { Skeleton } from '../../../../Skeleton'

import * as styles from './RentalPortalViewingProfileHeaderStatusSelectButton.module.css'

function RentalPortalViewingProfileHeaderStatusSelectButton({
  className,
  isSkeleton,
  qaName,
  ref,
  refs,
  ...restProps
}) {
  const { blocked, disabled, value } = useSelectContext() || EMPTY_OBJECT

  return isSkeleton ? (
    <Skeleton className={classNames(styles.skeleton, className)} />
  ) : (
    <ButtonTextSelectControl
      {...restProps}
      buttonProps={{
        Button: Button.Select,
        className: styles.button,
        disabled: blocked || disabled,
        height: BUTTON_HEIGHT_40,
        qaName,
        style: {
          '--viewing-profile-header-status-select-color':
            value?.textColor || 'var(--secondary-text-color)',
        },
        text: value?.label,
        textClassName: styles.text,
      }}
      className={className}
      ref={ref}
      refs={refs}
    />
  )
}

export default RentalPortalViewingProfileHeaderStatusSelectButton
